import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast, ToastContainer } from "react-toastify";
import { apiClient } from '../utils/const';

function Register() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    fullName: '',
    mobileNo: '',
    email: '',
    gender: '',
    address: '',
    password: '',
    confirmPassword: ''
  });
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validateMobile = (mobile) => {
    const mobileRegex = /^[0-9]{10,15}$/;
    return mobileRegex.test(mobile);
  };

  const validateField = (name, value) => {
    let error = '';
    
    switch (name) {
      case 'fullName':
        if (!value.trim()) {
          error = 'Full name is required';
        }
        break;
      case 'mobileNo':
        if (!value.trim()) {
          error = 'Mobile number is required';
        } else if (!validateMobile(value.trim())) {
          error = 'Please enter a valid mobile number (10-15 digits)';
        }
        break;
      case 'email':
        if (value.trim() && !validateEmail(value.trim())) {
          error = 'Please enter a valid email address';
        }
        break;
      case 'password':
        if (!value) {
          error = 'Password is required';
        } else if (value.length < 6) {
          error = 'Password must be at least 6 characters long';
        }
        break;
      case 'confirmPassword':
        if (!value) {
          error = 'Please confirm your password';
        } else if (value !== formData.password) {
          error = 'Passwords do not match';
        }
        break;
      default:
        break;
    }
    
    return error;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Real-time validation
    const error = validateField(name, value);
    setValidationErrors(prev => ({
      ...prev,
      [name]: error
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    // Validate all fields
    const errors = {};
    Object.keys(formData).forEach((field) => {
      const error = validateField(field, formData[field]);
      if (error) errors[field] = error;
    });
  
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      toast.error("Please fix the validation errors", {
        position: "top-right",
        autoClose: 3000,
      });
      setLoading(false);
      return;
    }
  
    // Prepare userData payload (backend expects this key)
    const payload = {
      fullName: formData.fullName,
      mobileNo: formData.mobileNo,
      email: formData.email,
      gender: formData.gender,
      address: formData.address,
      password: formData.password,
    };
  
    try {
      const response = await apiClient.post('/adminuser.php', {
        action: "registerUser",
        payload,
      });
  
      const data = response.data;
      console.log("Registration response:", data);
  
      if (data.success) {
        toast.success('🎉 Registration completed successfully! Welcome to our platform.', {
          position: "top-right",
          autoClose: 4000,
        });
  
        // Reset form
        setFormData({
          fullName: '',
          mobileNo: '',
          email: '',
          gender: '',
          address: '',
          password: '',
          confirmPassword: '',
        });
  
        setValidationErrors({});
  
        // Optionally navigate after registration
        setTimeout(() => navigate('/login'), 1500);
      } else {
        toast.error(data.message || 'Registration failed', {
          position: "top-right",
          autoClose: 5000,
        });
      }
    } catch (err) {
      console.error("Registration error:", err);
      toast.error(err.message || 'Network error during registration', {
        position: "top-right",
        autoClose: 5000,
      });
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <>
      <ToastContainer />
      <div className="container-xxl">
        <div className="row vh-100 d-flex justify-content-center">
          <div className="col-12 align-self-center">
            <div className="card-body">
              <div className="row">
                <div className="col-lg-4 mx-auto">
                  <div className="card">
                    <div className="card-body p-0 auth-header-box rounded-top" style={{backgroundColor: '#4B2C3B', marginTop: '1.5rem'}}>
                      <div className="text-center p-3">
                        <a href="index.html" className="logo logo-admin">
                          <img
                            src="assets/images/or_logo.png"
                            height={100}
                            alt="logo"
                            className="auth-logo"
                          />
                        </a>
                        <h4 className="mt-2 mb-1 fw-semibold fs-18" style={{color: '#4B2C3B'}}>
                          Create an account
                        </h4>
                        <p className="fw-medium mb-0" style={{color: '#4B2C3B'}}>
                          Enter your detail to Create your account today.
                        </p>
                      </div>
                    </div>
                    <div className="card-body pt-0">
                      <form className="my-4" onSubmit={handleSubmit}>
                        <div className="form-group mb-2">
                          <label className="form-label" htmlFor="fullName">
                            Full Name <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control ${validationErrors.fullName ? 'is-invalid' : ''}`}
                            id="fullName"
                            name="fullName"
                            placeholder="Enter full name"
                            value={formData.fullName}
                            onChange={handleChange}
                            required
                          />
                          {validationErrors.fullName && (
                            <div className="invalid-feedback">
                              {validationErrors.fullName}
                            </div>
                          )}
                        </div>
                        {/*end form-group*/}
                        <div className="form-group mb-2">
                          <label className="form-label" htmlFor="mobileNo">
                            Mobile Number <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control ${validationErrors.mobileNo ? 'is-invalid' : ''}`}
                            id="mobileNo"
                            name="mobileNo"
                            placeholder="Enter mobile number"
                            value={formData.mobileNo}
                            onChange={handleChange}
                            required
                          />
                          {validationErrors.mobileNo && (
                            <div className="invalid-feedback">
                              {validationErrors.mobileNo}
                            </div>
                          )}
                        </div>
                        {/*end form-group*/}
                        <div className="form-group mb-2">
                          <label className="form-label" htmlFor="email">
                            Email
                          </label>
                          <input
                            type="email"
                            className={`form-control ${validationErrors.email ? 'is-invalid' : ''}`}
                            id="email"
                            name="email"
                            placeholder="Enter email"
                            value={formData.email}
                            onChange={handleChange}
                          />
                          {validationErrors.email && (
                            <div className="invalid-feedback">
                              {validationErrors.email}
                            </div>
                          )}
                        </div>
                        {/*end form-group*/}
                        <div className="form-group mb-2">
                          <label className="form-label">
                            Gender
                          </label>
                          <div className="d-flex gap-4">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="gender"
                                id="genderMale"
                                value="M"
                                checked={formData.gender === 'M'}
                                onChange={handleChange}
                              />
                              <label className="form-check-label" htmlFor="genderMale">
                                Male
                              </label>
                            </div>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="gender"
                                id="genderFemale"
                                value="F"
                                checked={formData.gender === 'F'}
                                onChange={handleChange}
                              />
                              <label className="form-check-label" htmlFor="genderFemale">
                                Female
                              </label>
                            </div>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="gender"
                                id="genderOther"
                                value="O"
                                checked={formData.gender === 'O'}
                                onChange={handleChange}
                              />
                              <label className="form-check-label" htmlFor="genderOther">
                                Other
                              </label>
                            </div>
                          </div>
                        </div>
                        {/*end form-group*/}
                        <div className="form-group mb-2">
                          <label className="form-label" htmlFor="address">
                            Address
                          </label>
                          <textarea
                            className="form-control"
                            id="address"
                            name="address"
                            placeholder="Enter address"
                            value={formData.address}
                            onChange={handleChange}
                            rows="3"
                          />
                        </div>
                        {/*end form-group*/}
                        <div className="form-group mb-1">
                          <label className="form-label" htmlFor="password">
                            Password <span className="text-danger">*</span>
                          </label>
                          <input
                            type="password"
                            className={`form-control ${validationErrors.password ? 'is-invalid' : ''}`}
                            name="password"
                            id="password"
                            placeholder="Enter password"
                            value={formData.password}
                            onChange={handleChange}
                            required
                          />
                          {validationErrors.password && (
                            <div className="invalid-feedback">
                              {validationErrors.password}
                            </div>
                          )}
                        </div>
                        {/*end form-group*/}
                        <div className="form-group mb-1">
                          <label className="form-label" htmlFor="confirmPassword">
                            Confirm Password <span className="text-danger">*</span>
                          </label>
                          <input
                            type="password"
                            className={`form-control ${validationErrors.confirmPassword ? 'is-invalid' : ''}`}
                            name="confirmPassword"
                            id="confirmPassword"
                            placeholder="Enter confirm password"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                            required
                          />
                          {validationErrors.confirmPassword && (
                            <div className="invalid-feedback">
                              {validationErrors.confirmPassword}
                            </div>
                          )}
                        </div>
                        <div className="form-group mb-0 row">
                          <div className="col-12">
                            <div className="d-grid mt-2">
                              <button 
                                className="btn btn-primary" 
                                type="submit"
                                style={{backgroundColor: '#4B2C3B', color: 'rgb(211, 175, 55)'}}
                                disabled={loading}
                              >
                                {loading ? 'Registering...' : 'Register'} 
                                <i className="fas fa-sign-in-alt ms-1" />
                              </button>
                            </div>
                          </div>
                        </div>{" "}
                      </form>
                      <div className="text-center">
                        <p className="text-muted">
                          Already have an account ?{" "}
                          <a 
                            href="/login" 
                            onClick={(e) => {
                              e.preventDefault();
                              navigate('/login');
                            }}
                            className="ms-1" 
                            style={{color: '#4B2C3B', cursor: 'pointer'}}
                          >
                            Log in
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Register